import { Component, inject } from '@angular/core';
import { setAgGridLicenseKey } from '@wdx/shared/components/ag-grid';
import { AppService } from './core/services/app/app.service';

setAgGridLicenseKey();

@Component({
    selector: 'cp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent {
    private appService = inject(AppService);

    isReady$ = this.appService.isReady$;
}
